module.exports = __webpack_public_path__ + "media/images/brand/errors/404_error-8c69d47a3040303d2968c4b644d27bcc.jpeg";